/**
 * Surprav Slideshow Web Component
 */

class SurpravSlideshow extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slides = this.querySelectorAll('.slideshow__slide');
    this.dots = this.querySelectorAll('.slideshow__dot');
    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = parseInt(this.dataset.interval) || 5000;
    this.timer = null;

    this.init();
  }

  init() {
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.goto);
        this.goTo(index);
        this.stopAutoplay();
      });
    });

    if (this.autoplay) {
      this.startAutoplay();
    }

    // Touch support
    let touchStartX = 0;
    this.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) this.next();
      if (touchEndX - touchStartX > 50) this.prev();
    }, { passive: true });
  }

  goTo(index) {
    if (index === this.currentIndex) return;
    
    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex]?.classList.remove('is-active');
    
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    
    this.slides[this.currentIndex].classList.add('is-active');
    this.dots[this.currentIndex]?.classList.add('is-active');
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  prev() {
    this.goTo(this.currentIndex - 1);
  }

  startAutoplay() {
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}

if (!customElements.get('surprav-slideshow')) {
  customElements.define('surprav-slideshow', SurpravSlideshow);
}
